import { useSelector } from "react-redux";

const useIsMyOrganization = () => {
  const generalInfo = useSelector((state) => state.renderGeneralInfo);
  const loggedInUserOrgId = generalInfo?.org_id;
  const isMyOrganization = (orgId) => {
    return loggedInUserOrgId?.toString() === orgId?.toString();
  };
  return isMyOrganization;
};

export default useIsMyOrganization;
